import React from "react";
import { TFunction, useTranslation } from "react-i18next";
import { ClientGrantStatus } from "../services/types";

interface Props {
	status: ClientGrantStatus;
}

export const getClientGrantStatusLabelTitle = (t: TFunction, status: ClientGrantStatus) => {
	const finalStatus = status === ClientGrantStatus.ACTIVE ? "ENABLED" : status;

	return finalStatus === ClientGrantStatus.REVOKED
		? t("lib:go_component.client_details.status.REVOKED")
		: t(`lib:enums.common.status.${finalStatus}`);
};

const ClientGrantStatusLabel = ({ status }: Props) => {
	const { t } = useTranslation();

	const getLabelClass = () => {
		switch (status) {
			case ClientGrantStatus.ACTIVE:
				return "success";
			case ClientGrantStatus.REVOKED:
				return "danger";
			default:
				return "";
		}
	};

	const labelClass = getLabelClass();

	return (
		<span className={`badge ${labelClass ? `bg-${labelClass}` : ""}`}>
			{getClientGrantStatusLabelTitle(t, status)}
		</span>
	);
};

export default ClientGrantStatusLabel;

//t("lib:go_component.client_details.status.REVOKED")
